import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$I =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$h = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$g = fails$h;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$g(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$f = fails$h;

var functionBindNative = !fails$f(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$g = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$g.bind(call$g) : function () {
  return call$g.apply(call$g, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$6 = FunctionPrototype$2.bind;
var call$f = FunctionPrototype$2.call;
var uncurryThis$i = NATIVE_BIND$2 && bind$6.bind(call$f, call$f);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$i(fn);
} : function (fn) {
  return fn && function () {
    return call$f.apply(fn, arguments);
  };
};

var uncurryThis$h = functionUncurryThis;

var toString$5 = uncurryThis$h({}.toString);
var stringSlice$1 = uncurryThis$h(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$5(it), 8, -1);
};

var global$H = global$I;
var uncurryThis$g = functionUncurryThis;
var fails$e = fails$h;
var classof$7 = classofRaw$1;

var Object$5 = global$H.Object;
var split$1 = uncurryThis$g(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$e(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split$1(it, '') : Object$5(it);
} : Object$5;

var global$G = global$I;

var TypeError$h = global$G.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (it == undefined) throw TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$3(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$l = function (argument) {
  return typeof argument == 'function';
};

var isCallable$k = isCallable$l;

var isObject$9 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$k(it);
};

var global$F = global$I;
var isCallable$j = isCallable$l;

var aFunction = function (argument) {
  return isCallable$j(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$F[namespace]) : global$F[namespace] && global$F[namespace][method];
};

var uncurryThis$f = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$f({}.isPrototypeOf);

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$E = global$I;
var userAgent$3 = engineUserAgent;

var process$3 = global$E.process;
var Deno$1 = global$E.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$d = fails$h;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$d(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$D = global$I;
var getBuiltIn$6 = getBuiltIn$8;
var isCallable$i = isCallable$l;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$D.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$i($Symbol) && isPrototypeOf$3($Symbol.prototype, Object$4(it));
};

var global$C = global$I;

var String$5 = global$C.String;

var tryToString$4 = function (argument) {
  try {
    return String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$B = global$I;
var isCallable$h = isCallable$l;
var tryToString$3 = tryToString$4;

var TypeError$g = global$B.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$8 = function (argument) {
  if (isCallable$h(argument)) return argument;
  throw TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$7 = aCallable$8;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$7(func);
};

var global$A = global$I;
var call$e = functionCall;
var isCallable$g = isCallable$l;
var isObject$8 = isObject$9;

var TypeError$f = global$A.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$g(fn = input.toString) && !isObject$8(val = call$e(fn, input))) return val;
  if (isCallable$g(fn = input.valueOf) && !isObject$8(val = call$e(fn, input))) return val;
  if (pref !== 'string' && isCallable$g(fn = input.toString) && !isObject$8(val = call$e(fn, input))) return val;
  throw TypeError$f("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var isPure = false;

var global$z = global$I;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$4(global$z, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$z[key] = value;
  } return value;
};

var global$y = global$I;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$y[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.4',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.4/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$x = global$I;
var requireObjectCoercible$2 = requireObjectCoercible$4;

var Object$3 = global$x.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return Object$3(requireObjectCoercible$2(argument));
};

var uncurryThis$e = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$e({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$d = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$4 = uncurryThis$d(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$4(++id + postfix, 36);
};

var global$w = global$I;
var shared$2 = shared$3.exports;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$2 = global$w.Symbol;
var symbolFor = Symbol$2 && Symbol$2['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$i = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$b(Symbol$2, name)) {
      WellKnownSymbolsStore[name] = Symbol$2[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$v = global$I;
var call$d = functionCall;
var isObject$7 = isObject$9;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$h = wellKnownSymbol$i;

var TypeError$e = global$v.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$h('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$d(exoticToPrim, input, pref);
    if (!isObject$7(result) || isSymbol$1(result)) return result;
    throw TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$u = global$I;
var isObject$6 = isObject$9;

var document$3 = global$u.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$6(document$3) && isObject$6(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$c = fails$h;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$c(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$9 = descriptors;
var call$c = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$4(!call$c(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$b = fails$h;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$b(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$t = global$I;
var isObject$5 = isObject$9;

var String$4 = global$t.String;
var TypeError$d = global$t.TypeError;

// `Assert: Type(argument) is Object`
var anObject$d = function (argument) {
  if (isObject$5(argument)) return argument;
  throw TypeError$d(String$4(argument) + ' is not an object');
};

var global$s = global$I;
var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$c = anObject$d;
var toPropertyKey$1 = toPropertyKey$3;

var TypeError$c = global$s.TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$c(O);
  P = toPropertyKey$1(P);
  anObject$c(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$c(O);
  P = toPropertyKey$1(P);
  anObject$c(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$5 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$9 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$9(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$c = functionUncurryThis;
var isCallable$f = isCallable$l;
var store$1 = sharedStore;

var functionToString = uncurryThis$c(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$f(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$r = global$I;
var isCallable$e = isCallable$l;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$r.WeakMap;

var nativeWeakMap = isCallable$e(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$q = global$I;
var uncurryThis$b = functionUncurryThis;
var isObject$4 = isObject$9;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$8 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$b = global$q.TypeError;
var WeakMap = global$q.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$4(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$b('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$b(store.get);
  var wmhas = uncurryThis$b(store.has);
  var wmset = uncurryThis$b(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$b(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$b(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$a = fails$h;
var isCallable$d = isCallable$l;
var hasOwn$7 = hasOwnProperty_1;
var defineProperty$3 = objectDefineProperty.f;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$3 = internalState;

var enforceInternalState = InternalStateModule$3.enforce;
var getInternalState$1 = InternalStateModule$3.get;

var CONFIGURABLE_LENGTH = !fails$a(function () {
  return defineProperty$3(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    defineProperty$3(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$3(value, 'length', { value: options.arity });
  }
  var state = enforceInternalState(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$d(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var global$p = global$I;
var isCallable$c = isCallable$l;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var makeBuiltIn = makeBuiltIn$2.exports;
var setGlobal$1 = setGlobal$3;

var defineBuiltIn$8 = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  if (isCallable$c(value)) makeBuiltIn(value, name, options);
  if (O === global$p) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return O;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$3(O, key, value);
  return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$a = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$a([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$6(hiddenKeys$2, key) && hasOwn$6(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$6(O, key = names[i++])) {
    ~indexOf(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$9 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$b = anObject$d;

var concat$1 = uncurryThis$9([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$b(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$4.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$9 = fails$h;
var isCallable$b = isCallable$l;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$b(detection) ? fails$9(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$o = global$I;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$7 = defineBuiltIn$8;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$o;
  } else if (STATIC) {
    target = global$o[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$o[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$7(target, key, sourceProperty, options);
  }
};

var classof$6 = classofRaw$1;
var global$n = global$I;

var engineIsNode = classof$6(global$n.process) == 'process';

var global$m = global$I;
var isCallable$a = isCallable$l;

var String$3 = global$m.String;
var TypeError$a = global$m.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$a(argument)) return argument;
  throw TypeError$a("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$8 = functionUncurryThis;
var anObject$a = anObject$d;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$8(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$a(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$g = wellKnownSymbol$i;

var TO_STRING_TAG$3 = wellKnownSymbol$g('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var getBuiltIn$4 = getBuiltIn$8;
var definePropertyModule$3 = objectDefineProperty;
var wellKnownSymbol$f = wellKnownSymbol$i;
var DESCRIPTORS$4 = descriptors;

var SPECIES$2 = wellKnownSymbol$f('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$3.f;

  if (DESCRIPTORS$4 && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$l = global$I;
var isPrototypeOf$2 = objectIsPrototypeOf;

var TypeError$9 = global$l.TypeError;

var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw TypeError$9('Incorrect invocation');
};

var wellKnownSymbol$e = wellKnownSymbol$i;

var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$k = global$I;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$9 = isCallable$l;
var classofRaw = classofRaw$1;
var wellKnownSymbol$d = wellKnownSymbol$i;

var TO_STRING_TAG$1 = wellKnownSymbol$d('toStringTag');
var Object$2 = global$k.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$2(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$9(O.callee) ? 'Arguments' : result;
};

var uncurryThis$7 = functionUncurryThis;
var fails$8 = fails$h;
var isCallable$8 = isCallable$l;
var classof$4 = classof$5;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$7(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$8(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$j = global$I;
var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$4;

var TypeError$8 = global$j.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$8(tryToString$2(argument) + ' is not a constructor');
};

var anObject$9 = anObject$d;
var aConstructor = aConstructor$1;
var wellKnownSymbol$c = wellKnownSymbol$i;

var SPECIES$1 = wellKnownSymbol$c('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$9(O).constructor;
  var S;
  return C === undefined || (S = anObject$9(C)[SPECIES$1]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$b = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$b.bind(apply$1) : function () {
  return call$b.apply(apply$1, arguments);
});

var uncurryThis$6 = functionUncurryThis;
var aCallable$6 = aCallable$8;
var NATIVE_BIND = functionBindNative;

var bind$5 = uncurryThis$6(uncurryThis$6.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getBuiltIn$2 = getBuiltIn$8;

var html$2 = getBuiltIn$2('document', 'documentElement');

var uncurryThis$5 = functionUncurryThis;

var arraySlice$2 = uncurryThis$5([].slice);

var global$i = global$I;

var TypeError$7 = global$i.TypeError;

var validateArgumentsLength$2 = function (passed, required) {
  if (passed < required) throw TypeError$7('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$h = global$I;
var apply = functionApply;
var bind$4 = functionBindContext;
var isCallable$7 = isCallable$l;
var hasOwn$3 = hasOwnProperty_1;
var fails$7 = fails$h;
var html$1 = html$2;
var arraySlice$1 = arraySlice$2;
var createElement = documentCreateElement$2;
var validateArgumentsLength$1 = validateArgumentsLength$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$h.setImmediate;
var clear = global$h.clearImmediate;
var process$2 = global$h.process;
var Dispatch = global$h.Dispatch;
var Function$1 = global$h.Function;
var MessageChannel = global$h.MessageChannel;
var String$2 = global$h.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$h.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$3(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$h.postMessage(String$2(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$1(arguments.length, 1);
    var fn = isCallable$7(handler) ? handler : Function$1(handler);
    var args = arraySlice$1(arguments, 1);
    queue$1[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$4(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$h.addEventListener &&
    isCallable$7(global$h.postMessage) &&
    !global$h.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$7(post)
  ) {
    defer = post;
    global$h.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$g = global$I;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$g.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$f = global$I;
var bind$3 = functionBindContext;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$f.MutationObserver || global$f.WebKitMutationObserver;
var document$2 = global$f.document;
var process$1 = global$f.process;
var Promise$1 = global$f.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$1(global$f, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$3(macrotask, global$f);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$e = global$I;

var hostReportErrors$1 = function (a, b) {
  var console = global$e.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$d = global$I;

var promiseNativeConstructor = global$d.Promise;

var engineIsBrowser = typeof window == 'object' && typeof Deno != 'object';

var global$c = global$I;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$6 = isCallable$l;
var isForced = isForced_1;
var inspectSource = inspectSource$4;
var wellKnownSymbol$b = wellKnownSymbol$i;
var IS_BROWSER = engineIsBrowser;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$b('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$6(global$c.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$8;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$b = _export;
var IS_NODE$1 = engineIsNode;
var global$b = global$I;
var call$a = functionCall;
var defineBuiltIn$6 = defineBuiltIn$8;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$4 = aCallable$8;
var isCallable$5 = isCallable$l;
var isObject$3 = isObject$9;
var anInstance$1 = anInstance$2;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue;
var InternalStateModule$2 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var setInternalState$2 = InternalStateModule$2.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$6 = global$b.TypeError;
var document$1 = global$b.document;
var process = global$b.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$b.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$3(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$6('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$a(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$b.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$b['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$a(task, global$b, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$a(task, global$b, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$6("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$a(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$1(this, PromisePrototype);
    aCallable$4(executor);
    call$a(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$6(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$5(onRejected) && onRejected;
    reaction.domain = IS_NODE$1 ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$6(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$a(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$b({ global: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$3(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var iterators = {};

var wellKnownSymbol$a = wellKnownSymbol$i;
var Iterators$4 = iterators;

var ITERATOR$8 = wellKnownSymbol$a('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$8] === it);
};

var classof$3 = classof$5;
var getMethod$1 = getMethod$3;
var Iterators$3 = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$i;

var ITERATOR$7 = wellKnownSymbol$9('iterator');

var getIteratorMethod$3 = function (it) {
  if (it != undefined) return getMethod$1(it, ITERATOR$7)
    || getMethod$1(it, '@@iterator')
    || Iterators$3[classof$3(it)];
};

var global$a = global$I;
var call$9 = functionCall;
var aCallable$3 = aCallable$8;
var anObject$8 = anObject$d;
var tryToString$1 = tryToString$4;
var getIteratorMethod$2 = getIteratorMethod$3;

var TypeError$5 = global$a.TypeError;

var getIterator$2 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$8(call$9(iteratorMethod, argument));
  throw TypeError$5(tryToString$1(argument) + ' is not iterable');
};

var call$8 = functionCall;
var anObject$7 = anObject$d;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$7(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$8(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$7(innerResult);
  return value;
};

var global$9 = global$I;
var bind$1 = functionBindContext;
var call$7 = functionCall;
var anObject$6 = anObject$d;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator$1 = getIterator$2;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose = iteratorClose$1;

var TypeError$4 = global$9.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$6(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw TypeError$4(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$2(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$1(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$7(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$8 = wellKnownSymbol$i;

var ITERATOR$6 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$6] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$6] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$a = _export;
var call$6 = functionCall;
var aCallable$2 = aCallable$8;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$a({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$6($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$9 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$8;
var isCallable$4 = isCallable$l;
var defineBuiltIn$5 = defineBuiltIn$8;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$9({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$4(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$5(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$8 = _export;
var call$5 = functionCall;
var aCallable$1 = aCallable$8;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$8({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$5($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$7 = _export;
var call$4 = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call$4(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$5 = anObject$d;
var isObject$2 = isObject$9;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject$2(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$6 = _export;
var getBuiltIn = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$6({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var GetOneBillingInfosByClientIdErrors;

(function (GetOneBillingInfosByClientIdErrors) {
  GetOneBillingInfosByClientIdErrors[GetOneBillingInfosByClientIdErrors["inexistingBillingInfos"] = 0] = "inexistingBillingInfos";
})(GetOneBillingInfosByClientIdErrors || (GetOneBillingInfosByClientIdErrors = {}));

var UsageRestrictionsErrors;

(function (UsageRestrictionsErrors) {
  UsageRestrictionsErrors[UsageRestrictionsErrors["inexistingClientBillingInfos"] = 0] = "inexistingClientBillingInfos";
  UsageRestrictionsErrors[UsageRestrictionsErrors["currentConversationPeriodUsageFreeErrors"] = 1] = "currentConversationPeriodUsageFreeErrors";
})(UsageRestrictionsErrors || (UsageRestrictionsErrors = {}));

var StripeSubscriptionUpdatedErrors;

(function (StripeSubscriptionUpdatedErrors) {
  StripeSubscriptionUpdatedErrors[StripeSubscriptionUpdatedErrors["inexistingClientBillingInfos"] = 0] = "inexistingClientBillingInfos";
  StripeSubscriptionUpdatedErrors[StripeSubscriptionUpdatedErrors["currentConversationPeriodUsageFreeErrors"] = 1] = "currentConversationPeriodUsageFreeErrors";
})(StripeSubscriptionUpdatedErrors || (StripeSubscriptionUpdatedErrors = {}));

var GetOneClientUserByUserIdErrors;

(function (GetOneClientUserByUserIdErrors) {
  GetOneClientUserByUserIdErrors[GetOneClientUserByUserIdErrors["inexistingClientUser"] = 0] = "inexistingClientUser";
})(GetOneClientUserByUserIdErrors || (GetOneClientUserByUserIdErrors = {}));

var GetOneClientUserByEmailErrors;

(function (GetOneClientUserByEmailErrors) {
  GetOneClientUserByEmailErrors[GetOneClientUserByEmailErrors["inexistingUserProfile"] = 0] = "inexistingUserProfile";
  GetOneClientUserByEmailErrors[GetOneClientUserByEmailErrors["inexistingClientUser"] = 1] = "inexistingClientUser";
})(GetOneClientUserByEmailErrors || (GetOneClientUserByEmailErrors = {}));

var UpdateClientRestrictionsAfterSubscriptionUpdateErrors;

(function (UpdateClientRestrictionsAfterSubscriptionUpdateErrors) {
  UpdateClientRestrictionsAfterSubscriptionUpdateErrors[UpdateClientRestrictionsAfterSubscriptionUpdateErrors["inexistingClient"] = 0] = "inexistingClient";
  UpdateClientRestrictionsAfterSubscriptionUpdateErrors[UpdateClientRestrictionsAfterSubscriptionUpdateErrors["inexistingCurrentPlan"] = 1] = "inexistingCurrentPlan";
})(UpdateClientRestrictionsAfterSubscriptionUpdateErrors || (UpdateClientRestrictionsAfterSubscriptionUpdateErrors = {}));

var GetOneClientDetailsErrors;

(function (GetOneClientDetailsErrors) {
  GetOneClientDetailsErrors[GetOneClientDetailsErrors["inexistingClientDetails"] = 0] = "inexistingClientDetails";
})(GetOneClientDetailsErrors || (GetOneClientDetailsErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get GetOneBillingInfosByClientIdErrors () { return GetOneBillingInfosByClientIdErrors; },
	get GetOneClientDetailsErrors () { return GetOneClientDetailsErrors; },
	get GetOneClientUserByEmailErrors () { return GetOneClientUserByEmailErrors; },
	get GetOneClientUserByUserIdErrors () { return GetOneClientUserByUserIdErrors; },
	get StripeSubscriptionUpdatedErrors () { return StripeSubscriptionUpdatedErrors; },
	get UpdateClientRestrictionsAfterSubscriptionUpdateErrors () { return UpdateClientRestrictionsAfterSubscriptionUpdateErrors; },
	get UsageRestrictionsErrors () { return UsageRestrictionsErrors; }
});

const getOneBillingInfosByClientId$1 = authenticatedRequest => async clientId => {
  try {
    return await authenticatedRequest('get', `/v1/clients/${clientId}/billings-infos`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingBillingInfos':
          return GetOneBillingInfosByClientIdErrors.inexistingBillingInfos;

        default:
          throw genericUtils.sanitizeError(error);
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneClientUserById = axios => async userId => {
  try {
    return (await axios.get(`/v1/users/${userId}/client-user`)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingClientUser':
          return GetOneClientUserByUserIdErrors.inexistingClientUser;

        default:
          throw genericUtils.sanitizeError(error);
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestBillingInfosRequestToBillingInfos = restBillingInfosRequest => ({
  billingId: restBillingInfosRequest.billingId,
  clientId: restBillingInfosRequest.clientId,
  portalUrl: restBillingInfosRequest.portalUrl
});

const convertRestClientUserToClientUser = restClientUser => ({
  clientId: restClientUser.clientId,
  userId: restClientUser.userId
});

const getOneBillingInfos$1 = authenticatedRequest => async clientId => {
  const result = await getOneBillingInfosByClientId$1(authenticatedRequest)(clientId);

  if (genericUtils.isDomainError(result, GetOneBillingInfosByClientIdErrors)) {
    return result;
  }

  return convertRestBillingInfosRequestToBillingInfos(result);
};

const getOneClientUserByUserId$2 = axios => async userId => {
  const result = await getOneClientUserById(axios)(userId);

  if (genericUtils.isDomainError(result, GetOneClientUserByUserIdErrors)) {
    return result;
  }

  return convertRestClientUserToClientUser(result);
};

var index$a = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneBillingInfos: getOneBillingInfos$1,
	getOneClientUserByUserId: getOneClientUserByUserId$2
});

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$4 = anObject$d;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */

var anObject$3 = anObject$d;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$7 = wellKnownSymbol$i;
var create$2 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$7('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$6 = fails$h;

var correctPrototypeGetter = !fails$6(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$8 = global$I;
var hasOwn$2 = hasOwnProperty_1;
var isCallable$3 = isCallable$l;
var toObject$2 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$1 = global$8.Object;
var ObjectPrototype = Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$1.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$3(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$1 ? ObjectPrototype : null;
};

var fails$5 = fails$h;
var isCallable$2 = isCallable$l;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$4 = defineBuiltIn$8;
var wellKnownSymbol$6 = wellKnownSymbol$i;

var ITERATOR$5 = wellKnownSymbol$6('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$5(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$2(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$4(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$2 = setToStringTag$4;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$5 = _export;
var call$3 = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$l;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$4;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var defineBuiltIn$3 = defineBuiltIn$8;
var wellKnownSymbol$5 = wellKnownSymbol$i;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$3(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$3(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$5({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$3(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$7 = global$I;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol$4 = wellKnownSymbol$i;

var ITERATOR$3 = wellKnownSymbol$4('iterator');
var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$7[COLLECTION_NAME] && global$7[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const getOneRestClientDetails = authenticatedRequest => async userId => {
  try {
    return await authenticatedRequest('get', `/v1/users/${userId}/client-details`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingClientDetails':
          return GetOneClientDetailsErrors.inexistingClientDetails;

        default:
          throw genericUtils.sanitizeError(error);
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestClientDetailsToClientDetails = restClientDetails => {
  return {
    bots: restClientDetails.bots,
    businessSector: restClientDetails.businessSector,
    clientId: restClientDetails.clientId,
    currentPlan: restClientDetails.currentPlan,
    email: restClientDetails.email,
    hasPaymentMethod: restClientDetails.hasPaymentMethod,
    onboardingType: restClientDetails.onboardingType,
    selectedBot: restClientDetails.selectedBot,
    subscriptionOptions: restClientDetails.subscriptionOptions
  };
};

const convertRestClientDetailsToLocalStorageClientDetails = restClientDetails => {
  return {
    tolk_client_business_sector: restClientDetails.businessSector,
    tolk_client_onboarding_source: restClientDetails.onboardingType
  };
};

const saveLocalStorageClientDetails = localStorage => localStorageClientDetails => {
  Object.entries(localStorageClientDetails).map(([key, value]) => {
    return localStorage.setItem(key, value);
  });
};

const getOneClientDetails$1 = (authenticatedRequest, localStorage) => async userId => {
  const result = await getOneRestClientDetails(authenticatedRequest)(userId);

  if (genericUtils.isDomainError(result, GetOneClientDetailsErrors)) {
    return result;
  }

  const localstorageClientDetails = convertRestClientDetailsToLocalStorageClientDetails(result);
  saveLocalStorageClientDetails(localStorage)(localstorageClientDetails);
  return convertRestClientDetailsToClientDetails(result);
};

var index$9 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneClientDetails: getOneClientDetails$1
});

var isObject$1 = isObject$9;
var classof$2 = classofRaw$1;
var wellKnownSymbol$3 = wellKnownSymbol$i;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var global$6 = global$I;
var isRegExp = isRegexp;

var TypeError$3 = global$6.TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError$3("The method doesn't accept regular expressions");
  } return it;
};

var global$5 = global$I;
var classof$1 = classof$5;

var String$1 = global$5.String;

var toString$3 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$1(argument);
};

var wellKnownSymbol$2 = wellKnownSymbol$i;

var MATCH = wellKnownSymbol$2('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$4 = _export;
var uncurryThis$4 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$4;
var toString$2 = toString$3;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$4(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$4({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$2(requireObjectCoercible$1(this)),
      toString$2(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const getManyPgUserBotByUserId = pool => async userId => {
  try {
    return (await pool.query(`SELECT
              user_id,
              bot_id
            FROM "user_bot"
            WHERE user_id = $1
            ORDER BY id ASC;`, [userId])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgBot = pool => async () => {
  try {
    return (await pool.query(`SELECT
            DISTINCT("bot".bot_id)
          FROM "bot";`, [])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneRestBotByBotId = botManagementExpressAxios => async botId => {
  try {
    return (await botManagementExpressAxios.get(`/v1/bots/${botId}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyRestBotByBotIds = botManagementExpressAxios => async botIds => {
  try {
    const result = await Promise.all(botIds.map(async botId => {
      return getOneRestBotByBotId(botManagementExpressAxios)(botId);
    }));

    if (genericUtils.isEmpty(result)) {
      throw new Error('Client does not have any bot');
    }

    return result;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneUserPermissionsByUserId = pool => async userId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
            user_id,
            role
          FROM  "user_permission"
          WHERE user_id = $1;`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getPgBotsByUserId = pool => async userId => {
  try {
    return (await pool.query(`SELECT
            DISTINCT("bot".bot_id)
          FROM bot
          INNER JOIN client on client.id = bot.client_id
          INNER JOIN client_user on client_user.client_id = client.id
          WHERE client_user.user_id = $1`, [userId])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestBotToBot = restBot => {
  return {
    id: restBot.id,
    name: restBot.name
  };
};

const convertRestBotsToBots = restBots => {
  return restBots.map(restBot => {
    return convertRestBotToBot(restBot);
  });
};

const convertPgUserBotToRestBotIds = pgUserBots => pgUserBots.map(pgUserBot => pgUserBot.bot_id);

const convertPgBotToRestBotIds = pgBots => pgBots.map(pgBot => pgBot.bot_id);

const extractBotByUserRole = (pool, botManagementExpressAxios) => async (userId, userBotIds, userRole) => {
  switch (userRole) {
    case 'tolk-super-admin':
      {
        if (genericUtils.isEmpty(userBotIds)) {
          const bots = await getManyPgBot(pool)();
          const botIds = convertPgBotToRestBotIds(bots);

          const _restBots = await getManyRestBotByBotIds(botManagementExpressAxios)(botIds);

          const restBotsActivate = _restBots.filter(restBot => !restBot.archived);

          return convertRestBotsToBots(restBotsActivate);
        }

        const restBots = await getManyRestBotByBotIds(botManagementExpressAxios)(userBotIds);
        return convertRestBotsToBots(restBots);
      }

    case 'tolk-admin':
    case 'tolk-user':
      {
        const bots = await getPgBotsByUserId(pool)(userId);
        const botIds = convertPgBotToRestBotIds(bots);

        if (userBotIds.length > genericUtils.ARRAY.EMPTY_LENGTH) {
          const userBotIdsInBotIds = userBotIds.filter(userBotId => botIds.includes(userBotId));

          if (genericUtils.isEmpty(userBotIdsInBotIds)) {
            return [];
          }

          const restBots = await getManyRestBotByBotIds(botManagementExpressAxios)(userBotIdsInBotIds);
          return convertRestBotsToBots(restBots);
        }

        const restUserBots = await getManyRestBotByBotIds(botManagementExpressAxios)(botIds);
        return convertRestBotsToBots(restUserBots);
      }

    default:
      return [];
  }
};

const getManyBotsByUserId = (pool, botManagementAxios) => async userId => {
  const userPermission = await getOneUserPermissionsByUserId(pool)(userId);

  if (userPermission === null) {
    return [];
  }

  const userBots = await getManyPgUserBotByUserId(pool)(userId);
  const userBotIds = convertPgUserBotToRestBotIds(userBots);
  const extractedBotByUserRole = await extractBotByUserRole(pool, botManagementAxios)(userId, userBotIds, userPermission.role);
  return extractedBotByUserRole;
};

var index$8 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getManyBotsByUserId: getManyBotsByUserId
});

const updateAgentConfigurationByBotsAgent$1 = botManagementAxios => async botsAgent => {
  try {
    await botManagementAxios.post(`/v1/bots-agent`, botsAgent);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateAgentConfigurationByBotsAgent = botManagementAxios => async botsAgent => {
  await updateAgentConfigurationByBotsAgent$1(botManagementAxios)(botsAgent);
};

var index$7 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	updateAgentConfigurationByBotsAgent: updateAgentConfigurationByBotsAgent
});

var global$4 = global$I;
var aCallable = aCallable$8;
var toObject$1 = toObject$4;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;

var TypeError$2 = global$4.TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject$1(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$1(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError$2('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$4 = fails$h;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$4(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$3 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$3({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

const getOnePgClientBillingInfosByClientId$1 = pool => async clientId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "client".client_id,
              billing_id
            FROM "client_billing_info"
            INNER JOIN "client" ON "client".id = "client_billing_info".client_id
            WHERE "client".client_id = $1;`, [clientId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgClientBillingInfosByBillingId = pool => async billingId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "client".client_id,
              billing_id
            FROM "client_billing_info"
            INNER JOIN "client" ON "client".id = "client_billing_info".client_id
            WHERE billing_id = $1;`, [billingId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgBotsByClientId$1 = pool => async clientId => {
  try {
    return (await pool.query(`SELECT
                bot_id
                FROM "bot"
                WHERE client_id = (SELECT id FROM client WHERE client_id=$1);
                `, [clientId])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgClientBots = pool => async () => {
  try {
    return (await pool.query(`SELECT
            bot_id,
            client.client_id
          FROM "bot"
          INNER JOIN client ON client.id = bot.client_id;
          `)).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgClientByUserId = pool => async userId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              client.client_id,
              name,
              website_url,
              business_sector,
              email
            FROM "client"
            INNER JOIN client_user ON client_user.client_id = client.id
            WHERE client_user.user_id = $1;`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgClientUserByUserId = pool => async userId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "client".client_id,
              user_id
            FROM "client_user"
            INNER JOIN "client" ON "client".id = "client_user".client_id
            WHERE user_id = $1;`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgClientUserToClientUser = pgClientUser => ({
  clientId: pgClientUser.client_id,
  userId: pgClientUser.user_id
});

const convertPgClientToClient = pgClient => ({
  businessSector: pgClient.business_sector,
  email: pgClient.email,
  id: pgClient.client_id,
  name: pgClient.name
});

const convertPgBotsToClientBots = (pgBots, clientId) => ({
  bots: pgBots.map(pgBot => pgBot.bot_id),
  clientId
});

const convertPgClientBillingInfosToClientBillingInfos = pgClientBillingInfos => ({
  billingId: pgClientBillingInfos.billing_id,
  clientId: pgClientBillingInfos.client_id
});

const convertPgClientBotsToClientsBots = pgClientBots => {
  const clientsBotsMap = pgClientBots.reduce((accumulator, value) => {
    const bots = accumulator.get(value.client_id);

    if (typeof bots === 'undefined') {
      accumulator.set(value.client_id, [value.bot_id]);
    } else {
      accumulator.set(value.client_id, [...bots, value.bot_id]);
    }

    return accumulator;
  }, new Map());
  return [...clientsBotsMap.keys()].map(clientId => {
    var _a;

    return {
      bots: (_a = clientsBotsMap.get(clientId)) !== null && _a !== void 0 ? _a : [],
      clientId
    };
  });
};

const getOneClientBotsByClientId = pool => async clientId => {
  const pgBots = await getManyPgBotsByClientId$1(pool)(clientId);
  return convertPgBotsToClientBots(pgBots, clientId);
};

const getAllClientBots$1 = pool => async () => {
  const pgBots = await getManyPgClientBots(pool)();
  return convertPgClientBotsToClientsBots(pgBots);
};

const getOneClientByUserId = pool => async userId => {
  const client = await getOnePgClientByUserId(pool)(userId);

  if (client === null) {
    return null;
  }

  return convertPgClientToClient(client);
};

const getOneClientUserByUserId$1 = pool => async userId => {
  const clientUser = await getOnePgClientUserByUserId(pool)(userId);

  if (clientUser === null) {
    return null;
  }

  return convertPgClientUserToClientUser(clientUser);
};

const getOneClientBillingInfosByClientId = pool => async clientId => {
  const clientBillingInfos = await getOnePgClientBillingInfosByClientId$1(pool)(clientId);

  if (clientBillingInfos === null) {
    return null;
  }

  return convertPgClientBillingInfosToClientBillingInfos(clientBillingInfos);
};

const getOneClientBillingInfosByBillingId = pool => async billingId => {
  const clientBillingInfos = await getOnePgClientBillingInfosByBillingId(pool)(billingId);

  if (clientBillingInfos === null) {
    return null;
  }

  return convertPgClientBillingInfosToClientBillingInfos(clientBillingInfos);
};

var index$6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getAllClientBots: getAllClientBots$1,
	getOneClientBillingInfosByBillingId: getOneClientBillingInfosByBillingId,
	getOneClientBillingInfosByClientId: getOneClientBillingInfosByClientId,
	getOneClientBotsByClientId: getOneClientBotsByClientId,
	getOneClientByUserId: getOneClientByUserId,
	getOneClientUserByUserId: getOneClientUserByUserId$1
});

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$3 = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$4;
var toString$1 = toString$3;
var whitespaces$1 = whitespaces$2;

var replace$1 = uncurryThis$3(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$1(string, ltrim, '');
    if (TYPE & 2) string = replace$1(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var global$3 = global$I;
var fails$3 = fails$h;
var uncurryThis$2 = functionUncurryThis;
var toString = toString$3;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt = global$3.parseInt;
var Symbol$1 = global$3.Symbol;
var ITERATOR$2 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$2(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$2 && !fails$3(function () { $parseInt(Object(ITERATOR$2)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;

var $$2 = _export;
var parseInt = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es-x/no-number-parseint -- required for testing
$$2({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});

var DESCRIPTORS$1 = descriptors;
var uncurryThis$1 = functionUncurryThis;
var call$2 = functionCall;
var fails$2 = fails$h;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$1([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$2(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$2(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$1 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$1({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var fails$1 = fails$h;
var wellKnownSymbol$1 = wellKnownSymbol$i;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var nativeUrl = !fails$1(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltIn$2 = defineBuiltIn$8;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$2(target, key, src[key], options);
  return target;
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var global$2 = global$I;
var toAbsoluteIndex = toAbsoluteIndex$2;
var lengthOfArrayLike = lengthOfArrayLike$4;
var createProperty = createProperty$1;

var Array$1 = global$2.Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array$1(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var arraySlice = arraySliceSimple;

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $ = _export;
var global$1 = global$I;
var call$1 = functionCall;
var uncurryThis = functionUncurryThis;
var DESCRIPTORS = descriptors;
var USE_NATIVE_URL = nativeUrl;
var defineBuiltIn$1 = defineBuiltIn$8;
var defineBuiltIns = defineBuiltIns$1;
var setToStringTag = setToStringTag$4;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule = internalState;
var anInstance = anInstance$2;
var isCallable = isCallable$l;
var hasOwn$1 = hasOwnProperty_1;
var bind = functionBindContext;
var classof = classof$5;
var anObject$2 = anObject$d;
var isObject = isObject$9;
var $toString$1 = toString$3;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var getIterator = getIterator$2;
var getIteratorMethod = getIteratorMethod$3;
var validateArgumentsLength = validateArgumentsLength$2;
var wellKnownSymbol = wellKnownSymbol$i;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global$1[name];
  var descriptor = getOwnPropertyDescriptor(global$1, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$1.RegExp;
var TypeError$1 = global$1.TypeError;
var decodeURIComponent = global$1.decodeURIComponent;
var encodeURIComponent = global$1.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString$1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$1(next, iterator)).done) {
        entryIterator = getIterator(anObject$2(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$1(entryNext, entryIterator)).done ||
          (second = call$1(entryNext, entryIterator)).done ||
          !call$1(entryNext, entryIterator).done
        ) throw TypeError$1('Expected sequence with length 2');
        push(this.entries, { key: $toString$1(first.value), value: $toString$1(second.value) });
      }
    } else for (var key in object) if (hasOwn$1(object, key)) {
      push(this.entries, { key: key, value: $toString$1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$1(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$1(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString$1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, noTargetGet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true, noTargetGet: true }, {
      Request: RequestConstructor
    });
  }
}

var anObject$1 = anObject$d;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$8;
var anObject = anObject$d;
var $toString = toString$3;
var fails = fails$h;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const getOnePgClientBillingInfosByClientId = pool => async clientId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "client".client_id,
              billing_id
            FROM "client_billing_info"
            INNER JOIN "client" ON "client".id = "client_billing_info".client_id
            WHERE "client".client_id = $1;`, [clientId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePortalUrlStripeByPgBillingId = stripeAxios => async billingId => {
  try {
    const uri = '/v1/billing_portal/sessions';
    const data = new URLSearchParams();
    data.append('customer', billingId);
    const result = (await stripeAxios.post(uri, data)).data;
    return result.url;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getAllPgPlans = pool => async () => {
  try {
    const plans = await pool.query(`SELECT
          plan_id,
          stripe_price_id
          FROM plan;`);
    return plans.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getAllSubscriptionsByBillingId = stripeAxios => async billingId => {
  try {
    const subscriptions = (await stripeAxios.get(`/v1/customers/${billingId}/subscriptions`)).data;
    return subscriptions.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgProductsToStripePriceIds = pgProducts => pgProducts.map(pgProduct => pgProduct.stripe_price_id);

const subscriptionStatusAccepted = new Set(['active', 'trialing', 'past_due', 'unpaid']);

const findSubscriptionsByStatusAndStripePricesId = (subscriptions, pgPlans) => {
  const subscriptionsfilteredByStatus = subscriptions.filter(subscriptionItem => subscriptionStatusAccepted.has(subscriptionItem.status));
  const stripePricesId = convertPgProductsToStripePriceIds(pgPlans);
  const result = subscriptionsfilteredByStatus.find(subscription => subscription.items.data.some(item => stripePricesId.includes(item.price.id)));

  if (!result) {
    return null;
  }

  return result;
};

const convertMetadataToStripePriceMetadata = metadata => ({
  bots_available_number: typeof metadata.bots_available_number === 'string' ? metadata.bots_available_number : '0',
  conversations_available_number: typeof metadata.conversations_available_number === 'string' ? metadata.conversations_available_number : '0',
  users_available_number: typeof metadata.users_available_number === 'string' ? metadata.users_available_number : '0'
});

const findSubscriptionItemInSubscription = (subscription, products) => {
  const subscriptionItems = subscription.items.data.map(subscriptionItem => ({
    id: subscriptionItem.id,
    price: {
      id: subscriptionItem.price.id,
      metadata: convertMetadataToStripePriceMetadata(subscriptionItem.price.metadata)
    }
  }));
  const stripePricesId = convertPgProductsToStripePriceIds(products);
  const result = subscriptionItems.find(item => stripePricesId.includes(item.price.id));

  if (!result) {
    return null;
  }

  return result;
};

const findPlanIdInSubcriptionItem = (stripePriceId, pgPlans) => {
  const currentPlan = pgPlans.find(plan => plan.stripe_price_id === stripePriceId);

  if (!currentPlan) {
    return null;
  }

  return currentPlan.plan_id;
};

const getClientConversationsCountByDate = botManagementAxios => async (clientId, startDate, endDate) => {
  try {
    const searchParameters = new URLSearchParams();
    searchParameters.append('startDate', genericUtils.formatDate(startDate, 'number-with-year'));
    searchParameters.append('endDate', genericUtils.formatDate(endDate, 'number-with-year'));
    return (await botManagementAxios.get(`/v1/clients/${clientId}/conversations-count?${searchParameters.toString()}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgClientDetailsByUserId = pool => async userId => {
  try {
    return (await pool.query(`SELECT
            client.client_id,
            client.email,
            client.business_sector,
            client_billing_info.billing_id,
            client.onboarding_type
          FROM client_user
          INNER JOIN client
          ON client.id = client_user.client_id
          INNER JOIN client_billing_info
          ON client.id = client_billing_info.client_id
          WHERE client_user.user_id = $1;`, [userId])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneRestStripeCardPaymentMethodsByBillingId = axios => async billingId => {
  try {
    const searchParameters = new URLSearchParams();
    searchParameters.append('type', 'card');
    return (await axios.get(`/v1/customers/${billingId}/payment_methods?${searchParameters.toString()}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneRestStripeSepaPaymentMethodsByBillingId = axios => async billingId => {
  try {
    const searchParameters = new URLSearchParams();
    searchParameters.append('type', 'sepa_debit');
    return (await axios.get(`/v1/customers/${billingId}/payment_methods?${searchParameters.toString()}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getAllPgSubscriptionOptions = pool => async () => {
  try {
    const subscriptionOption = await pool.query(`SELECT
          option_id,
          stripe_price_id
          FROM subscription_option;`);
    return subscriptionOption.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const findSubscriptionItemOptionsInSubscription = (subscription, pgSubscriptionOptions) => {
  const subscriptionItems = subscription.items.data.map(subscriptionItem => ({
    id: subscriptionItem.id,
    price: {
      id: subscriptionItem.price.id,
      metadata: convertMetadataToStripePriceMetadata(subscriptionItem.price.metadata)
    }
  }));
  const stripePricesId = convertPgProductsToStripePriceIds(pgSubscriptionOptions);
  const result = subscriptionItems.filter(item => stripePricesId.includes(item.price.id));
  return result;
};

const findSubscriptionOptionIdsInSubcriptionItem = (stripePriceIds, pgSubscriptionOptions) => {
  const subscriptionOptionIds = pgSubscriptionOptions.filter(pgSubscriptionOption => stripePriceIds.includes(pgSubscriptionOption.stripe_price_id));

  if (subscriptionOptionIds.length === genericUtils.ARRAY.EMPTY_LENGTH) {
    return [];
  }

  return subscriptionOptionIds.map(subscriptionOption => subscriptionOption.option_id);
};

const getOneBillingInfosByClientId = (pool, stripeAxios) => async clientId => {
  const billingInfos = await getOnePgClientBillingInfosByClientId(pool)(clientId);

  if (billingInfos === null) {
    return null;
  }

  const portalUrl = await getOnePortalUrlStripeByPgBillingId(stripeAxios)(billingInfos.billing_id);
  return {
    billingId: billingInfos.billing_id,
    clientId,
    portalUrl
  };
};

const getOneCurrentConversationPeriodUsageByClientBillingInfos = (pool, stripeAxios, botManagementAxios) => async clientBillingInfos => {
  const subscriptions = await getAllSubscriptionsByBillingId(stripeAxios)(clientBillingInfos.billingId);
  const pgPlans = await getAllPgPlans(pool)();
  const subscription = findSubscriptionsByStatusAndStripePricesId(subscriptions, pgPlans);

  if (subscription === null) {
    return null;
  }

  const subscriptionItem = findSubscriptionItemInSubscription(subscription, pgPlans);

  if (subscriptionItem === null) {
    return null;
  }

  const conversationCount = await getClientConversationsCountByDate(botManagementAxios)(clientBillingInfos.clientId, new Date(subscription.current_period_start * genericUtils.TIME.MILLISECONDS_IN_A_SECOND), new Date(subscription.current_period_end * genericUtils.TIME.MILLISECONDS_IN_A_SECOND));
  return {
    clientId: clientBillingInfos.clientId,
    conversationCount: conversationCount.count,
    conversationsAvailableNumber: Number.parseInt(subscriptionItem.price.metadata.conversations_available_number, 10)
  };
};

const getOneClientSubscriptionDetailsByUserId = (pool, stripeAxios, botManagementExpressAxios) => async userId => {
  const pgClientDetails = await getOnePgClientDetailsByUserId(pool)(userId);

  if (genericUtils.isEmpty(pgClientDetails)) {
    return null;
  }

  const pgPlans = await getAllPgPlans(pool)();
  const pgClientDetail = pgClientDetails[genericUtils.ARRAY.FIRST_INDEX];
  const restStripeCardPaymentMethods = await getOneRestStripeCardPaymentMethodsByBillingId(stripeAxios)(pgClientDetail.billing_id);
  const restStripeSepaPaymentMethods = await getOneRestStripeSepaPaymentMethodsByBillingId(stripeAxios)(pgClientDetail.billing_id);
  const clientSubscriptionDetailsWithoutPlan = {
    businessSector: pgClientDetail.business_sector,
    clientId: pgClientDetail.client_id,
    currentPlan: null,
    email: pgClientDetail.email,
    hasPaymentMethod: !genericUtils.isEmpty(restStripeCardPaymentMethods.data) || !genericUtils.isEmpty(restStripeSepaPaymentMethods.data),
    onboardingType: pgClientDetail.onboarding_type,
    subscriptionOptions: []
  };
  const subscriptions = await getAllSubscriptionsByBillingId(stripeAxios)(pgClientDetail.billing_id);
  const subscription = findSubscriptionsByStatusAndStripePricesId(subscriptions, pgPlans);

  if (subscription === null) {
    return clientSubscriptionDetailsWithoutPlan;
  }

  const pgSubscriptionOptions = await getAllPgSubscriptionOptions(pool)();
  const subscriptionItemsOptions = findSubscriptionItemOptionsInSubscription(subscription, pgSubscriptionOptions);
  const subscriptionOptionIds = subscriptionItemsOptions.length === genericUtils.ARRAY.EMPTY_LENGTH ? [] : findSubscriptionOptionIdsInSubcriptionItem(subscriptionItemsOptions.map(subscriptionItemsOption => subscriptionItemsOption.price.id), pgSubscriptionOptions);
  const clientSubscriptionDetailsWithPlanWithOption = Object.assign(Object.assign({}, clientSubscriptionDetailsWithoutPlan), {
    subscriptionOptions: subscriptionOptionIds
  });
  const subscriptionItemPlan = findSubscriptionItemInSubscription(subscription, pgPlans);

  if (subscriptionItemPlan === null) {
    return clientSubscriptionDetailsWithPlanWithOption;
  }

  const planId = findPlanIdInSubcriptionItem(subscriptionItemPlan.price.id, pgPlans);

  if (planId === null) {
    return clientSubscriptionDetailsWithPlanWithOption;
  }

  const conversationCount = await getClientConversationsCountByDate(botManagementExpressAxios)(pgClientDetail.client_id, new Date(subscription.current_period_start * genericUtils.TIME.MILLISECONDS_IN_A_SECOND), new Date(subscription.current_period_end * genericUtils.TIME.MILLISECONDS_IN_A_SECOND));
  const currentPlan = {
    areLimitsReached: conversationCount.count >= Number.parseInt(subscriptionItemPlan.price.metadata.conversations_available_number, 10),
    clientId: pgClientDetail.client_id,
    planId,
    subscriptionDate: new Date(subscription.start_date * genericUtils.TIME.MILLISECONDS_IN_A_SECOND)
  };
  return Object.assign(Object.assign({}, clientSubscriptionDetailsWithPlanWithOption), {
    currentPlan
  });
};

const getOneCurrentPlanByClientId = (pool, stripeAxios, botManagementExpressAxios) => async clientId => {
  const pgClientBillingInfos = await getOnePgClientBillingInfosByClientId(pool)(clientId);

  if (pgClientBillingInfos === null) {
    return null;
  }

  const pgPlans = await getAllPgPlans(pool)();
  const subscriptions = await getAllSubscriptionsByBillingId(stripeAxios)(pgClientBillingInfos.billing_id);
  const subscription = findSubscriptionsByStatusAndStripePricesId(subscriptions, pgPlans);

  if (subscription === null) {
    return null;
  }

  const subscriptionItem = findSubscriptionItemInSubscription(subscription, pgPlans);

  if (subscriptionItem === null) {
    return null;
  }

  const planId = findPlanIdInSubcriptionItem(subscriptionItem.price.id, pgPlans);

  if (planId === null) {
    return null;
  }

  const conversationCount = await getClientConversationsCountByDate(botManagementExpressAxios)(clientId, new Date(subscription.current_period_start * genericUtils.TIME.MILLISECONDS_IN_A_SECOND), new Date(subscription.current_period_end * genericUtils.TIME.MILLISECONDS_IN_A_SECOND));
  return {
    areLimitsReached: conversationCount.count >= Number.parseInt(subscriptionItem.price.metadata.conversations_available_number, 10),
    clientId,
    planId,
    subscriptionDate: new Date(subscription.start_date * genericUtils.TIME.MILLISECONDS_IN_A_SECOND)
  };
};

var index$5 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneBillingInfosByClientId: getOneBillingInfosByClientId,
	getOneClientSubscriptionDetailsByUserId: getOneClientSubscriptionDetailsByUserId,
	getOneCurrentConversationPeriodUsageByClientBillingInfos: getOneCurrentConversationPeriodUsageByClientBillingInfos,
	getOneCurrentPlanByClientId: getOneCurrentPlanByClientId
});

const disableAutomatedConversationOnOneBot = axios => // eslint-disable-next-line @typescript-eslint/require-await
async pgBot => {
  // botid
  try {
    await axios.post(`/v1/bots-agent`, {
      agent: true,
      botId: pgBot.bot_id
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const disableAutomatedConversationOnAllBots$1 = axios => // eslint-disable-next-line @typescript-eslint/require-await
async pgBots => {
  await Promise.all(pgBots.map(async pgBot => disableAutomatedConversationOnOneBot(axios)(pgBot)));
};

const enableAutomatedConversationOnOneBots = axios => // eslint-disable-next-line @typescript-eslint/require-await
async pgBot => {
  // botid
  try {
    await axios.post(`/v1/bots-agent`, {
      agent: false,
      botId: pgBot.bot_id
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const enableAutomatedConversationOnAllBots$1 = axios => // eslint-disable-next-line @typescript-eslint/require-await
async pgBots => {
  await Promise.all(pgBots.map(async pgBot => enableAutomatedConversationOnOneBots(axios)(pgBot)));
};

const getManyPgBotsByClientId = pool => async clientId => {
  try {
    const pgBots = (await pool.query(`SELECT
            bot_id
            FROM "bot"
            WHERE client_id = (SELECT id FROM client WHERE client_id=$1);
            `, [clientId])).rows;

    if (genericUtils.isEmpty(pgBots)) {
      throw new Error('Client does not have any bot');
    }

    return pgBots;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const disableAutomatedConversationOnAllBots = (axios, pool) => async clientId => {
  const pgBots = await getManyPgBotsByClientId(pool)(clientId);
  await disableAutomatedConversationOnAllBots$1(axios)(pgBots);
};

const enableAutomatedConversationOnAllBots = (axios, pool) => async clientId => {
  const pgBots = await getManyPgBotsByClientId(pool)(clientId);
  await enableAutomatedConversationOnAllBots$1(axios)(pgBots);
};

var index$4 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	disableAutomatedConversationOnAllBots: disableAutomatedConversationOnAllBots,
	enableAutomatedConversationOnAllBots: enableAutomatedConversationOnAllBots
});

const getOneUserProfileByEmail$1 = axios => async email => {
  try {
    return (await axios.get(`/v1/user-accounts/${email}/login`)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneUserProfileByUserId$1 = axios => async userId => {
  try {
    return (await axios.get(`/v1/user-accounts/${userId}/login`)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestUserProfileToUserProfile = restUserProfile => ({
  email: restUserProfile.email,
  id: restUserProfile.id
});

const getOneUserProfileByEmail = axios => async email => {
  const userProfile = await getOneUserProfileByEmail$1(axios)(email);

  if (userProfile === null) {
    return null;
  }

  return convertRestUserProfileToUserProfile(userProfile);
};

const getOneUserProfileByUserId = axios => async userId => {
  const userProfile = await getOneUserProfileByUserId$1(axios)(userId);

  if (userProfile === null) {
    return null;
  }

  return convertRestUserProfileToUserProfile(userProfile);
};

var index$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneUserProfileByEmail: getOneUserProfileByEmail,
	getOneUserProfileByUserId: getOneUserProfileByUserId
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestClientBusinessSector: {
		type: "string",
		"enum": [
			"e-commerce",
			"administration",
			"assurances",
			"automobile",
			"banque",
			"batiment",
			"energies",
			"fashion",
			"food",
			"immobilier",
			"services",
			"travel"
		]
	},
	RestPlanId: {
		type: "string",
		"enum": [
			"free",
			"start",
			"grow",
			"liberty"
		]
	},
	RestOnboardingType: {
		type: "string",
		"enum": [
			"email",
			"shopify"
		]
	},
	RestSubscriptionOptionId: {
		type: "string"
	},
	RestCurrentPlan: {
		type: "object",
		properties: {
			planId: {
				$ref: "#/definitions/RestPlanId"
			},
			clientId: {
				type: "string"
			},
			subscriptionDate: {
				type: "string",
				format: "date-time"
			},
			areLimitsReached: {
				type: "boolean"
			}
		},
		required: [
			"planId",
			"clientId",
			"subscriptionDate",
			"areLimitsReached"
		],
		additionalProperties: false
	},
	RestBot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestBotId"
			},
			name: {
				type: "string"
			}
		},
		required: [
			"id",
			"name"
		],
		additionalProperties: false
	},
	RestBotId: {
		type: "string"
	},
	RestBots: {
		type: "array",
		items: {
			$ref: "#/definitions/RestBot"
		}
	},
	RestClientDetails: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			businessSector: {
				$ref: "#/definitions/RestClientBusinessSector"
			},
			email: {
				type: "string"
			},
			onboardingType: {
				$ref: "#/definitions/RestOnboardingType"
			},
			currentPlan: {
				anyOf: [
					{
						type: "null"
					},
					{
						$ref: "#/definitions/RestCurrentPlan"
					}
				]
			},
			bots: {
				$ref: "#/definitions/RestBots"
			},
			selectedBot: {
				$ref: "#/definitions/RestBot"
			},
			hasPaymentMethod: {
				type: "boolean"
			},
			subscriptionOptions: {
				type: "array",
				items: {
					$ref: "#/definitions/RestSubscriptionOptionId"
				}
			}
		},
		required: [
			"clientId",
			"businessSector",
			"email",
			"onboardingType",
			"currentPlan",
			"bots",
			"selectedBot",
			"hasPaymentMethod",
			"subscriptionOptions"
		],
		additionalProperties: false
	},
	LocalStorageClientDetails: {
		type: "object",
		properties: {
			tolk_client_business_sector: {
				$ref: "#/definitions/RestClientBusinessSector"
			},
			tolk_client_onboarding_source: {
				$ref: "#/definitions/RestOnboardingType"
			}
		},
		required: [
			"tolk_client_business_sector",
			"tolk_client_onboarding_source"
		],
		additionalProperties: false
	},
	RestClientIdRequest: {
		type: "string"
	},
	RestBillingInfosRequest: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			portalUrl: {
				type: "string"
			},
			billingId: {
				type: "string"
			}
		},
		required: [
			"clientId",
			"portalUrl",
			"billingId"
		],
		additionalProperties: false
	},
	RestClientUser: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			userId: {
				type: "string"
			}
		},
		required: [
			"clientId",
			"userId"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			},
			name: {
				type: "string"
			}
		},
		required: [
			"id",
			"name"
		],
		additionalProperties: false
	},
	Bots: {
		type: "array",
		items: {
			$ref: "#/definitions/Bot"
		}
	},
	BotAgent: {
		type: "object",
		properties: {
			botId: {
				$ref: "#/definitions/BotId"
			},
			agent: {
				type: "boolean"
			}
		},
		required: [
			"botId",
			"agent"
		],
		additionalProperties: false
	},
	BotsAgent: {
		type: "array",
		items: {
			$ref: "#/definitions/BotAgent"
		}
	},
	PlanId: {
		type: "string",
		"enum": [
			"free",
			"start",
			"grow",
			"liberty"
		]
	},
	Plan: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/PlanId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	UserId: {
		type: "string"
	},
	UserEmail: {
		type: "string"
	},
	UserProfile: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/UserId"
			},
			email: {
				$ref: "#/definitions/UserEmail"
			}
		},
		required: [
			"id",
			"email"
		],
		additionalProperties: false
	},
	User: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/UserId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	ClientBusinessSector: {
		type: "string",
		"enum": [
			"e-commerce",
			"administration",
			"assurances",
			"automobile",
			"banque",
			"batiment",
			"energies",
			"fashion",
			"food",
			"immobilier",
			"services",
			"travel"
		]
	},
	OnboardingType: {
		type: "string",
		"enum": [
			"email",
			"shopify"
		]
	},
	ClientId: {
		type: "string"
	},
	BillingId: {
		type: "string"
	},
	SubscriptionOptionId: {
		type: "string"
	},
	CurrentConversationPeriodUsage: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			conversationCount: {
				type: "number"
			},
			conversationsAvailableNumber: {
				type: "number"
			}
		},
		required: [
			"clientId",
			"conversationCount",
			"conversationsAvailableNumber"
		],
		additionalProperties: false
	},
	Client: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ClientId"
			},
			name: {
				type: "string"
			},
			businessSector: {
				$ref: "#/definitions/ClientBusinessSector"
			},
			email: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"businessSector",
			"email"
		],
		additionalProperties: false
	},
	CurrentPlan: {
		type: "object",
		properties: {
			planId: {
				$ref: "#/definitions/PlanId"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			subscriptionDate: {
				type: "string",
				format: "date-time"
			},
			areLimitsReached: {
				type: "boolean"
			}
		},
		required: [
			"planId",
			"clientId",
			"subscriptionDate",
			"areLimitsReached"
		],
		additionalProperties: false
	},
	ClientSubscriptionDetails: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			businessSector: {
				$ref: "#/definitions/ClientBusinessSector"
			},
			email: {
				type: "string"
			},
			onboardingType: {
				$ref: "#/definitions/OnboardingType"
			},
			currentPlan: {
				anyOf: [
					{
						type: "null"
					},
					{
						$ref: "#/definitions/CurrentPlan"
					}
				]
			},
			hasPaymentMethod: {
				type: "boolean"
			},
			subscriptionOptions: {
				type: "array",
				items: {
					$ref: "#/definitions/SubscriptionOptionId"
				}
			}
		},
		required: [
			"clientId",
			"businessSector",
			"email",
			"onboardingType",
			"currentPlan",
			"hasPaymentMethod",
			"subscriptionOptions"
		],
		additionalProperties: false
	},
	ClientDetails: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			businessSector: {
				$ref: "#/definitions/ClientBusinessSector"
			},
			email: {
				type: "string"
			},
			onboardingType: {
				$ref: "#/definitions/OnboardingType"
			},
			currentPlan: {
				anyOf: [
					{
						type: "null"
					},
					{
						$ref: "#/definitions/CurrentPlan"
					}
				]
			},
			bots: {
				$ref: "#/definitions/Bots"
			},
			selectedBot: {
				$ref: "#/definitions/Bot"
			},
			hasPaymentMethod: {
				type: "boolean"
			},
			subscriptionOptions: {
				type: "array",
				items: {
					$ref: "#/definitions/SubscriptionOptionId"
				}
			}
		},
		required: [
			"clientId",
			"businessSector",
			"email",
			"onboardingType",
			"currentPlan",
			"bots",
			"selectedBot",
			"hasPaymentMethod",
			"subscriptionOptions"
		],
		additionalProperties: false
	},
	BillingInfos: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			},
			portalUrl: {
				type: "string"
			}
		},
		required: [
			"clientId",
			"billingId",
			"portalUrl"
		],
		additionalProperties: false
	},
	ClientBots: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			bots: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		required: [
			"clientId",
			"bots"
		],
		additionalProperties: false
	},
	ClientsBots: {
		type: "array",
		items: {
			$ref: "#/definitions/ClientBots"
		}
	},
	ClientUser: {
		type: "object",
		properties: {
			userId: {
				$ref: "#/definitions/UserId"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			}
		},
		required: [
			"userId",
			"clientId"
		],
		additionalProperties: false
	},
	ClientBillingInfos: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			}
		},
		required: [
			"clientId",
			"billingId"
		],
		additionalProperties: false
	},
	RestBotIds: {
		type: "array",
		items: {
			$ref: "#/definitions/RestBotId"
		}
	},
	PgUserBot: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			}
		},
		required: [
			"user_id",
			"bot_id"
		],
		additionalProperties: false
	},
	PgBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	PgUserRole: {
		type: "string",
		"enum": [
			"tolk-super-admin",
			"tolk-admin",
			"tolk-user"
		]
	},
	PgUserPermission: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			role: {
				$ref: "#/definitions/PgUserRole"
			}
		},
		required: [
			"user_id",
			"role"
		],
		additionalProperties: false
	},
	AgentId: {
		type: "string"
	},
	PgSubscriptionOptionId: {
		type: "string"
	},
	PgClientBusinessSector: {
		type: "string",
		"enum": [
			"e-commerce",
			"administration",
			"assurances",
			"automobile",
			"banque",
			"batiment",
			"energies",
			"fashion",
			"food",
			"immobilier",
			"services",
			"travel"
		]
	},
	PgOnboardingType: {
		type: "string",
		"enum": [
			"email",
			"shopify"
		]
	},
	PgClient: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			business_sector: {
				$ref: "#/definitions/PgClientBusinessSector"
			},
			client_id: {
				$ref: "#/definitions/PgClientId"
			},
			email: {
				type: "string"
			}
		},
		required: [
			"name",
			"business_sector",
			"client_id",
			"email"
		],
		additionalProperties: false
	},
	PgClientId: {
		type: "string"
	},
	PgClientAgentInfos: {
		type: "object",
		properties: {
			client_id: {
				$ref: "#/definitions/ClientId"
			},
			agent_id: {
				$ref: "#/definitions/AgentId"
			}
		},
		required: [
			"client_id",
			"agent_id"
		],
		additionalProperties: false
	},
	PgClientBillingInfos: {
		type: "object",
		properties: {
			client_id: {
				$ref: "#/definitions/PgClientId"
			},
			billing_id: {
				$ref: "#/definitions/PgBillingId"
			}
		},
		required: [
			"client_id",
			"billing_id"
		],
		additionalProperties: false
	},
	PgBillingId: {
		type: "string"
	},
	CreateStripeCustomerAnswer: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BillingId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	CreateOneAgentIdAnswer: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/AgentId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	UrlPortalSession: {
		type: "string"
	},
	RestPortalSession: {
		type: "object",
		properties: {
			url: {
				$ref: "#/definitions/UrlPortalSession"
			}
		},
		required: [
			"url"
		],
		additionalProperties: false
	},
	PgPlanId: {
		type: "string",
		"enum": [
			"free",
			"start",
			"grow",
			"liberty"
		]
	},
	PgPlan: {
		type: "object",
		properties: {
			plan_id: {
				$ref: "#/definitions/PgPlanId"
			},
			stripe_price_id: {
				type: "string"
			}
		},
		required: [
			"plan_id",
			"stripe_price_id"
		],
		additionalProperties: false
	},
	SubscriptionItemId: {
		type: "string"
	},
	PriceId: {
		type: "string"
	},
	RestStripePriceMetadata: {
		type: "object",
		properties: {
			bots_available_number: {
				type: "string"
			},
			users_available_number: {
				type: "string"
			},
			conversations_available_number: {
				type: "string"
			}
		},
		required: [
			"bots_available_number",
			"users_available_number",
			"conversations_available_number"
		],
		additionalProperties: false
	},
	RestStripeSubscriptionItem: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/SubscriptionItemId"
			},
			price: {
				type: "object",
				properties: {
					id: {
						$ref: "#/definitions/PriceId"
					},
					metadata: {
						$ref: "#/definitions/RestStripePriceMetadata"
					}
				},
				required: [
					"id",
					"metadata"
				],
				additionalProperties: false
			}
		},
		required: [
			"id",
			"price"
		],
		additionalProperties: false
	},
	RestStripeSubscription: {
		type: "object",
		properties: {
			created: {
				type: "number"
			},
			start_date: {
				type: "number"
			},
			current_period_end: {
				type: "number"
			},
			current_period_start: {
				type: "number"
			},
			items: {
				type: "object",
				properties: {
					data: {
						type: "array",
						items: {
							$ref: "#/definitions/RestStripeSubscriptionItem"
						}
					}
				},
				required: [
					"data"
				],
				additionalProperties: false
			},
			trial_end: {
				type: [
					"number",
					"null"
				]
			},
			status: {
				type: "string"
			}
		},
		required: [
			"created",
			"start_date",
			"current_period_end",
			"current_period_start",
			"items",
			"trial_end",
			"status"
		],
		additionalProperties: false
	},
	RestStripeSubscriptionsData: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/RestStripeSubscription"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	RestConversationCount: {
		type: "object",
		properties: {
			startDate: {
				type: "string"
			},
			endDate: {
				type: "string"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"startDate",
			"endDate",
			"clientId",
			"count"
		],
		additionalProperties: false
	},
	PgClientDetail: {
		type: "object",
		properties: {
			client_id: {
				type: "string"
			},
			business_sector: {
				$ref: "#/definitions/PgClientBusinessSector"
			},
			billing_id: {
				type: "string"
			},
			email: {
				type: "string"
			},
			onboarding_type: {
				$ref: "#/definitions/PgOnboardingType"
			}
		},
		required: [
			"client_id",
			"business_sector",
			"billing_id",
			"email",
			"onboarding_type"
		],
		additionalProperties: false
	},
	PgClientDetails: {
		type: "array",
		items: {
			$ref: "#/definitions/PgClientDetail"
		}
	},
	RestStripeCardPaymentMethod: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			billing_details: {
				type: "object",
				properties: {
					name: {
						type: [
							"string",
							"null"
						]
					}
				},
				required: [
					"name"
				],
				additionalProperties: false
			},
			card: {
				type: "object",
				properties: {
					brand: {
						type: "string"
					},
					exp_month: {
						type: "number"
					},
					exp_year: {
						type: "number"
					},
					last4: {
						type: "string"
					}
				},
				required: [
					"brand",
					"exp_month",
					"exp_year",
					"last4"
				],
				additionalProperties: false
			},
			type: {
				type: "string",
				"const": "card"
			}
		},
		required: [
			"id",
			"billing_details",
			"card",
			"type"
		],
		additionalProperties: false
	},
	RestStripeCardPaymentMethods: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/RestStripeCardPaymentMethod"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	RestStripeSepaPaymentMethod: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			billing_details: {
				type: "object",
				properties: {
					name: {
						type: [
							"string",
							"null"
						]
					},
					email: {
						type: "string"
					}
				},
				required: [
					"name",
					"email"
				],
				additionalProperties: false
			},
			sepa_debit: {
				type: "object",
				properties: {
					bank_code: {
						type: "string"
					},
					branch_code: {
						type: "string"
					},
					country: {
						type: "string"
					},
					fingerprint: {
						type: "string"
					},
					last4: {
						type: "string"
					}
				},
				required: [
					"bank_code",
					"branch_code",
					"country",
					"fingerprint",
					"last4"
				],
				additionalProperties: false
			},
			type: {
				type: "string",
				"const": "sepa_debit"
			}
		},
		required: [
			"id",
			"billing_details",
			"sepa_debit",
			"type"
		],
		additionalProperties: false
	},
	RestStripeSepaPaymentMethods: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/RestStripeSepaPaymentMethod"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	PgSubscriptionOption: {
		type: "object",
		properties: {
			option_id: {
				$ref: "#/definitions/PgSubscriptionOptionId"
			},
			stripe_price_id: {
				type: "string"
			}
		},
		required: [
			"option_id",
			"stripe_price_id"
		],
		additionalProperties: false
	},
	PgBots: {
		type: "array",
		items: {
			$ref: "#/definitions/PgBot"
		}
	},
	PgClientUser: {
		type: "object",
		properties: {
			client_id: {
				type: "string"
			},
			user_id: {
				type: "string"
			}
		},
		required: [
			"client_id",
			"user_id"
		],
		additionalProperties: false
	},
	PgClientBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			client_id: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"client_id"
		],
		additionalProperties: false
	},
	PgClientBots: {
		type: "array",
		items: {
			$ref: "#/definitions/PgClientBot"
		}
	},
	RestClient: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	RestUserProfile: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			email: {
				type: "string"
			}
		},
		required: [
			"id",
			"email"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	$schema: $schema,
	definitions: definitions,
	'default': entitiesSchemas
});

const botsAgentFactory = (clientBots, agent) => {
  return clientBots.bots.map(bot => ({
    agent,
    botId: bot
  }));
};

var index$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	botsAgentFactory: botsAgentFactory
});

var index$1 = /*#__PURE__*/Object.freeze({
	__proto__: null
});

var ToggleAutomatedConversationsActivationErrors;

(function (ToggleAutomatedConversationsActivationErrors) {
  ToggleAutomatedConversationsActivationErrors[ToggleAutomatedConversationsActivationErrors["inexistingCurrentPlan"] = 0] = "inexistingCurrentPlan";
})(ToggleAutomatedConversationsActivationErrors || (ToggleAutomatedConversationsActivationErrors = {}));

var ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors;

(function (ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors) {
  ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors[ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors["inexistingClient"] = 0] = "inexistingClient";
  ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors[ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors["inexistingCurrentPlan"] = 1] = "inexistingCurrentPlan";
})(ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors || (ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors = {}));

const toggleAutomatedConversationsActivation$1 = (getOneCurrentPlanByClientId, disableAutomatedConversationOnAllBots, enableAutomatedConversationOnAllBots) => async clientId => {
  const currentPlan = await getOneCurrentPlanByClientId(clientId);

  if (currentPlan === null) {
    return ToggleAutomatedConversationsActivationErrors.inexistingCurrentPlan;
  }

  if (currentPlan.planId !== 'free') {
    return;
  }

  if (currentPlan.areLimitsReached) {
    await disableAutomatedConversationOnAllBots(clientId);
    return;
  }

  await enableAutomatedConversationOnAllBots(clientId);
};

const toggleAutomatedConversationsActivationAfterSubscriptionUpdate = (getOneClientBillingInfosByBillingId, getOneCurrentPlanByClientId, enableAutomatedConversationOnAllBots) => async billingId => {
  const clientBillingInfos = await getOneClientBillingInfosByBillingId(billingId);

  if (clientBillingInfos === null) {
    return ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors.inexistingClient;
  }

  const currentPlan = await getOneCurrentPlanByClientId(clientBillingInfos.clientId);

  if (currentPlan === null) {
    return ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors.inexistingCurrentPlan;
  }

  await enableAutomatedConversationOnAllBots(clientBillingInfos.clientId);
};

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	toggleAutomatedConversationsActivation: toggleAutomatedConversationsActivation$1,
	toggleAutomatedConversationsActivationAfterSubscriptionUpdate: toggleAutomatedConversationsActivationAfterSubscriptionUpdate,
	get ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors () { return ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors; },
	get ToggleAutomatedConversationsActivationErrors () { return ToggleAutomatedConversationsActivationErrors; }
});

const getOneBillingInfos = getOneBillingInfosByClientId => async clientId => {
  const billingInfos = await getOneBillingInfosByClientId(clientId);

  if (billingInfos === null) {
    return GetOneBillingInfosByClientIdErrors.inexistingBillingInfos;
  }

  return billingInfos;
};

const getOneClientBots = getOneClientBotsByClientId => async clientId => {
  const clientBots = await getOneClientBotsByClientId(clientId);
  return clientBots;
};

const getAllClientBots = getAllClientBots => async () => {
  const clientsBots = await getAllClientBots();
  return clientsBots;
};

const getOneClientUserByUserId = getOneClientUserByUserId => async userId => {
  const clientUser = await getOneClientUserByUserId(userId);

  if (clientUser === null) {
    return GetOneClientUserByUserIdErrors.inexistingClientUser;
  }

  return clientUser;
};

const getOneClientUserByEmail = (getOneUserProfileByEmail, getOneClientUserByUserId) => async email => {
  const userProfile = await getOneUserProfileByEmail(email);

  if (userProfile === null) {
    return GetOneClientUserByEmailErrors.inexistingUserProfile;
  }

  const clientUser = await getOneClientUserByUserId(userProfile.id);

  if (clientUser === null) {
    return GetOneClientUserByEmailErrors.inexistingClientUser;
  }

  return clientUser;
};

const toggleAutomatedConversationsActivation = toggleAutomatedConversationsActivation => async clientId => {
  await toggleAutomatedConversationsActivation(clientId);
};

const updateClientRestrictionsAfterSubscriptionUpdate = toggleAutomatedConversationsActivationAfterSubscriptionUpdate => async billingId => {
  const result = await toggleAutomatedConversationsActivationAfterSubscriptionUpdate(billingId);

  if (result === ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors.inexistingClient) {
    return UpdateClientRestrictionsAfterSubscriptionUpdateErrors.inexistingClient;
  }

  if (result === ToggleAutomatedConversationsActivationAfterSubscriptionUpdateErrors.inexistingCurrentPlan) {
    return UpdateClientRestrictionsAfterSubscriptionUpdateErrors.inexistingCurrentPlan;
  }
};

const getOneClientDetails = (getOneClientSubscriptionDetailsByUserId, getManyBotsByUserId) => async userId => {
  const clientSubscriptionDetails = await getOneClientSubscriptionDetailsByUserId(userId);

  if (clientSubscriptionDetails === null) {
    return GetOneClientDetailsErrors.inexistingClientDetails;
  }

  const bots = await getManyBotsByUserId(userId);
  const selectedBot = bots[genericUtils.ARRAY.FIRST_INDEX];
  return Object.assign(Object.assign({}, clientSubscriptionDetails), {
    bots,
    selectedBot
  });
};

export { applicationPorts as appPorts, index$a as axiosClients, index$7 as axiosClientsRepository, index$9 as axiosLocalStorageClients, index$3 as axiosUsersRepository, index$2 as botModel, index$1 as clientModel, entitiesSchemas$1 as entitiesSchemas, getAllClientBots, getOneBillingInfos, getOneClientBots, getOneClientDetails, getOneClientUserByEmail, getOneClientUserByUserId, index$8 as postgresqlAxiosBotsRepository, index$5 as postgresqlAxiosClientsRepository, index$4 as postgresqlAxiosConversationRestrictions, index$6 as postgresqlClientsRepository, toggleAutomatedConversationsActivation, updateClientRestrictionsAfterSubscriptionUpdate, index as usageRestrictions };
